
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTabUnselected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 119,
  viewBox: "0 0 35 119"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 32.542a10 10 0 0 1 7.362-9.646c.56-.154 1.11-.306 1.646-.458l1.058-.302c8.853-2.557 14.233-4.858 16.14-6.901 1.222-1.31 2.453-3.75 3.588-6.293l.211-.477.105-.24.208-.478.205-.476.203-.474c1.976-4.641 3.523-8.639 3.98-5.532.389 1.187.392 20.431.01 57.734.382 37.304.379 56.548-.01 57.735-.457 3.107-2.004-.891-3.98-5.532l-.203-.474-.205-.476-.208-.479-.105-.239-.211-.477c-1.135-2.542-2.366-4.983-3.588-6.293-1.907-2.043-7.287-4.344-16.14-6.901l-1.058-.302c-.537-.152-1.086-.304-1.646-.458A10 10 0 0 1 0 85.458V32.542z",
  fill: "#3D3C3D",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"35\" height=\"119\" viewBox=\"0 0 35 119\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#3D3C3D\">\r\n            <path d=\"M0 32.376c0-4.507 3.015-8.457 7.362-9.646.56-.154 1.11-.306 1.646-.458l1.058-.302c8.853-2.557 14.233-4.858 16.14-6.901 1.222-1.31 2.453-3.75 3.588-6.293l.211-.477.105-.24.208-.478.205-.476.203-.474c1.976-4.641 3.523-8.639 3.98-5.532.389 1.187.392 20.431.01 57.734.382 37.304.379 56.548-.01 57.735-.457 3.107-2.004-.891-3.98-5.532l-.203-.474-.205-.476-.208-.479-.105-.239-.211-.477c-1.135-2.542-2.366-4.983-3.588-6.293-1.907-2.043-7.287-4.344-16.14-6.901l-1.058-.302c-.537-.152-1.086-.304-1.646-.458C3.015 93.748 0 89.798 0 85.292V32.376z\" transform=\"translate(-1371 -330) translate(1371 330.166)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/tab-unselected.cae6b4bd82830f936abf148ac88c2294.svg"),
        {
          React: SvgTabUnselected,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      